/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';

import Router from 'next/router';

import _ from 'lodash';

import { FadeInAnimation, Button } from '../shared';

const SearchSection = (props) => {

    const { title, paragraph, cityName } = props;    

    const onFindASpaceClick = () => {
        Router.push(`/bookings?city=${cityName}`).then(() => window.scrollTo(0, 0));
    };

    return (
        <div className='container-root container-root-maxWidthLg'>
            <FadeInAnimation>
                <div className='play-page-search-section-text-container'>
                    <h2>{title}</h2>
                    <p className='play-page-search-section-paragraph'>{paragraph}</p>
                    <Button
                        id="find-a-space-button"
                        onClick={onFindASpaceClick}
                        className='play-page-search-section-styled-button'
                    >
                        Find a Space
                    </Button>
                </div>
            </FadeInAnimation>
        </div>
    );
};

export default SearchSection;

SearchSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    cityName: PropTypes.string,
    buildings: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

